import React from "react";
import { Row, Col } from "reactstrap";

import { useWizard } from "components/wizard/WizardContext";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";

import { MAPPING_YEAR_DROPDOWN, inputHeight } from "./helper";

const SelectYearStep = () => {
  const { updateValues, values, back, next } = useWizard();

  return (
    <>
      <h2>Select Year</h2>
      <Row>
        <Col md="6">
          <AAutoComplete
            label="Year*"
            placeholder="Select"
            height={inputHeight}
            items={MAPPING_YEAR_DROPDOWN}
            currentValue={values?.year}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              updateValues("year", value);
            }}
            inputKey="year"
          />
        </Col>
      </Row>

      <footer className="mt-4 d-flex justify-content-between">
        <AButton
          onClick={() => {
            // got to step 1
            back(0);
          }}
          className="button_remove_left_margin"
          variant="outline"
        >
          Back
        </AButton>

        <AButton
          disabled={!values?.year}
          onClick={() => {
            // got to step 3
            next();
          }}
          className="button_remove_left_margin"
          variant="primary_filled"
        >
          Next
        </AButton>
      </footer>
    </>
  );
};

export default SelectYearStep;
